import { Inject, Injectable, LOCALE_ID } from '@angular/core';
import { JsonApiManyResourcesDocument } from 'json-api';
import { Observable, of } from 'rxjs';
import { AtomParams, AtomService } from 'src/app/core/atom.service';
import { Users } from 'src/app/core/resources/user.resource';

@Injectable({
  providedIn: 'root',
})
export class UsersService {
  constructor(
    private atom: AtomService,
    @Inject(LOCALE_ID) public readonly locale: string
  ) {}

  all(params?: AtomParams): Observable<JsonApiManyResourcesDocument<Users>> {
    return this.atom.all(Users, params);
  }

  find(id: string, include?: string[]): Observable<Users> {
    if (id) {
      return this.atom.find(Users, id, { include });
    }
    return of(new Users());
  }
}
